import styled from "styled-components";

import Text from "@/components/Text";

const Box = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  padding: 16px;
`;

const Label = styled(Text)`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Description = styled(Text)`
  span {
    color: ${({ theme }) => theme.colors.black};
  }
`;

const AspectRatioNote = () => {
  return (
    <Box>
      <Label $type="smallBold">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="7.5" stroke="#E9E9E9" />
          <path
            d="M7.25 5.73529V4.5H8.75V5.73529H7.25ZM7.25 11.5V6.55882H8.75V11.5H7.25Z"
            fill="currentColor"
          />
        </svg>
        Note
      </Label>
      <Description $type="smallNormal" $color="gray">
        Ensure you select the appropriate image size for success following the
        test setup. The required aspect ratios are <span>1:1</span> or{" "}
        <span>1.91:1</span> (1080x1080 or 1200x628)
      </Description>
    </Box>
  );
};

export default AspectRatioNote;
